//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import AccEightColumnsBalanceDownloadView from '@/views/Accounting/AccEightColumnsBalance/AccEightColumnsBalanceDownload'

//
export default {
    path: 'eight_columns_balance',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'eight-columns-balance-download',
            component: AccEightColumnsBalanceDownloadView,
        },
    ],
    meta: {
        title: 'Balance de ocho columnas',
    },
}
